import * as React from "react";

import { FileInput } from "components/form/FileInput";
import { formattedJoinArray } from "utils/array";
import { FileUploadError, FileUploadErrorType } from "utils/file";

interface IProps {
  onChange: (file: File) => void;
  onError: (error: FileUploadError) => void;
  extensions: string[];
  maxSizeInMB?: number;
  className?: string;
  children: React.ReactNode;
  dataTestId?: string;
}

export class FilePicker extends React.PureComponent<IProps> {
  static defaultProps: Partial<IProps> = {
    maxSizeInMB: 2,
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  handleOnChange = (file: File) => {
    const { onError, onChange, maxSizeInMB, extensions } = this.props;

    if (!file) {
      onError(new FileUploadError("Failed to upload a file.", FileUploadErrorType.Unknown));
      return;
    }

    if (extensions) {
      // @ts-expect-error TS(2532): Object is possibly 'undefined'.
      const loadedFileExtension = file.name.split(".").pop().toLowerCase();
      const isExtensionValid = extensions.some(
        ext => ext.toLocaleLowerCase() === loadedFileExtension.toLocaleLowerCase()
      );

      if (!isExtensionValid) {
        onError(
          new FileUploadError(
            `${loadedFileExtension.toUpperCase()} extension is not supported. Please use ${formattedJoinArray(
              extensions.map(item => item.toUpperCase()),
              "or"
            )} format.`,
            FileUploadErrorType.InvalidExtension
          )
        );
        return;
      }
    }

    // @ts-expect-error TS(2532): Object is possibly 'undefined'.
    if (file.size > maxSizeInMB * 1000000) {
      onError(new FileUploadError(`File size must be less than ${maxSizeInMB} MB.`, FileUploadErrorType.InvalidSize));
      return;
    }

    onChange(file);
  };

  render(): JSX.Element {
    const { children, className, dataTestId } = this.props;

    return (
      <FileInput onChange={this.handleOnChange} className={className} dataTestId={dataTestId}>
        {children}
      </FileInput>
    );
  }
}
